import { useQuery } from "@tanstack/react-query";

import {
  getIncentivesByPlatformIdReferralHistoryByPersonId,
  getIncentivesByPlatformLocationIdActiveSignupReward,
  getIncentivesByPlatformLocationIdAvailableReferralReward,
  getPlatformCurrent,
  getUser,
} from "api/methods";
import { Models } from "@/api/types";

type Result = {
  showReferralRewards: boolean;
  showLegacyReferral: boolean;
  referralRewardForPlatformLocation?: Models<"DisplayAvailableReferralReward"> | null;
  activeSignupReward?: Models<"DisplayActiveReward"> | null;
};
export function useReferralRewardsFeature(): Result {
  const { data: platform } = useQuery({ ...getPlatformCurrent.keyed() });

  const { data: user } = useQuery({ ...getUser.keyed() });

  const { data: referralRewardForPlatformLocation } = useQuery({
    ...getIncentivesByPlatformLocationIdAvailableReferralReward.keyed({
      platformLocationId: user?.platformLocation?.id ?? "",
    }),
    onError: () => null,
  });

  const { data: activeSignupReward } = useQuery({
    ...getIncentivesByPlatformLocationIdActiveSignupReward.keyed({
      platformLocationId: user?.platformLocation?.id ?? "",
    }),
    onError: () => null,
  });

  const { data: referralHistoryForPerson } = useQuery({
    ...getIncentivesByPlatformIdReferralHistoryByPersonId.keyed({
      platformId: platform?.id || "",
      personId: user?.id || "",
    }),
    enabled: !!platform?.id && !!user?.id,
    onError: () => null,
  });

  const shouldShowReferralRewards = () => {
    if (referralHistoryForPerson?.referralHistory?.length) {
      return true;
    }

    return !!referralRewardForPlatformLocation && !!activeSignupReward && !user?.isGuest;
  };

  return {
    referralRewardForPlatformLocation,
    activeSignupReward,
    showReferralRewards: shouldShowReferralRewards(),
    showLegacyReferral: !user?.isGuest && !referralRewardForPlatformLocation,
  };
}
